import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";

export const useCalendarData = (selectedValue, selectedUser, auth) => {
  const [loading, setLoading] = useState(true);
  const [dates, setDates] = useState([]);

  useEffect(() => {
    setLoading(true);
    const params = {};

    if (auth.Rol === "director") {
      if (selectedUser !== "all") {
        params.u = selectedUser;
      }
    } else {
      params.u = auth.UID;
    }

    const year = moment(selectedValue).format("YYYY");
    const month = moment(selectedValue).format("MM");

    Promise.all([
      axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/calendario/visitas/${year}/${month}`, { params }),
      axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/calendario/solicitud/${year}/${month}`, { params }),
      axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/calendario/contrato/${year}/${month}`, { params }),
      axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/calendario/listo/${year}/${month}`, { params }),
      axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/calendario/emision/${year}/${month}`, { params }),
      axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/calendario/revision1/${year}/${month}`, { params }),
      axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/calendario/revision2/${year}/${month}`, { params }),
      axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/calendario/papeleria/${year}/${month}`, { params }),
      axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/calendario/cancelacion/${year}/${month}`, { params }),
    ])
      .then((response) => {
        let allDates = [];

        // Add debugging logs
        console.log(
          "API Responses:",
          response.map((res, index) => ({
            endpoint: index,
            data: res.data,
            length: res.data.length,
          }))
        );

        response.forEach((res, index) => {
          console.log(`Processing endpoint ${index}:`, res.data);

          res.data.forEach((date) => {
            console.log("Processing date item:", date);

            allDates.push({
              id: date.id,
              ControlInterno: date.ControlInterno,
              Fecha: date.Fecha.substring(0, 10),
              Hora1: date.Hora1,
              Hora2: date.Hora2,
              Tipo: date.Tipo,
              Verificador: date.Verificador,
              Status: date.Status,
              Monto: date.Monto,
            });
          });
        });

        console.log("All processed dates:", allDates);
        console.log(
          "Revision1 items:",
          allDates.filter((item) => item.Tipo === "revision1")
        );
        console.log(
          "Revision2 items:",
          allDates.filter((item) => item.Tipo === "revision2")
        );

        allDates.sort((a, b) => {
          return a.ControlInterno - b.ControlInterno;
        });

        setDates(allDates);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching calendar data:", err);
        setLoading(false);
      });
  }, [selectedValue, selectedUser, auth.Rol, auth.UID]);

  return { loading, dates };
};
